import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import SupplierPortalPage from '@/areas/quote-requests/SupplierPortal/SupplierPortalPage';
import { canAccessSupplierPortal } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/supplier-portal/')({
    // The navbar shows its "Supplier portal dev" entry as a developer shortcut, and hides it in production. Suppliers
    // arrive by email and from `/`, so the page stays open in production.
    staticData: { access: { permissions: canAccessSupplierPortal }, chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ filter: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <SupplierPortalPage />;
}
